import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import BalloonAvatar from "./BalloonAvatar";

const DialogueBox = props => {
    const wrapperClasses = classNames("dialogue-box-wrapper", props.className, {
        "dialogue-box-wrapper--thought-bubble": props.thoughtBubble
    });
    const classes = classNames("dialogue-box", props.className, {
        "dialogue-box--thought-bubble": props.thoughtBubble
    });

    const { bodyText, avatarName } = props;

    return (
        <div className={wrapperClasses}>
            <div className={classes}>
                <p className="dialogue-box__body-text">
                    &quot;
                    {bodyText}
                    &quot;
                </p>
            </div>
            <BalloonAvatar {...{ avatarName }} />
        </div>
    );
};

DialogueBox.propTypes = {
    className: PropTypes.string,
    bodyText: PropTypes.string.isRequired,
    avatarName: PropTypes.string.isRequired,
    thoughtBubble: PropTypes.bool
};

export default DialogueBox;



// WEBPACK FOOTER //
// ./src/components/landingPage/DialogueBox.jsx